// The agent's state, drawn as a pulli kolam: dots that breathe while listening, a line
// that traces the loop while thinking, and flows in turmeric while speaking.
export type OrbState = "connecting" | "listening" | "thinking" | "speaking" | "ended";

const DOTS: [number, number][] = [
  [20, 20], [50, 20], [80, 20],
  [20, 50], [50, 50], [80, 50],
  [20, 80], [50, 80], [80, 80],
];

// Four petals looping out from the centre around the edge dots: one continuous line.
const LOOP =
  "M50 50 C35 35 32 8 50 8 C68 8 65 35 50 50 " +
  "C65 35 92 32 92 50 C92 68 65 65 50 50 " +
  "C65 65 68 92 50 92 C32 92 35 65 50 50 " +
  "C35 65 8 68 8 50 C8 32 35 35 50 50 Z";

export function Kolam({ state, level }: { state: OrbState; level: number }) {
  // Speaking: the line thickens with the agent's voice.
  const width = state === "speaking" ? 2.2 + Math.min(1, level * 3) * 2.4 : 2.2;
  return (
    <svg class="kolam" data-state={state} viewBox="0 0 100 100" role="img" aria-label={`Agent is ${state}`}>
      <path class="kolam-line" d={LOOP} pathLength={100} style={{ strokeWidth: width }} />
      {DOTS.map(([x, y], i) => (
        <circle key={i} class="kolam-dot" cx={x} cy={y} r={2.6} style={{ animationDelay: `${(i % 3) * 120 + Math.floor(i / 3) * 120}ms` }} />
      ))}
    </svg>
  );
}
